"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyOfficerVerificationStatus = void 0;
var CompanyOfficerVerificationStatus;
(function (CompanyOfficerVerificationStatus) {
    CompanyOfficerVerificationStatus["NOT_STARTED"] = "not_started";
    CompanyOfficerVerificationStatus["VERIFIED"] = "verified";
    CompanyOfficerVerificationStatus["RETRY_ALLOWED"] = "retry";
    CompanyOfficerVerificationStatus["REJECTED"] = "rejected";
    CompanyOfficerVerificationStatus["PENDING"] = "pending";
    CompanyOfficerVerificationStatus["MANUAL_CHECK_REQUIRED"] = "manual_check_required";
})(CompanyOfficerVerificationStatus = exports.CompanyOfficerVerificationStatus || (exports.CompanyOfficerVerificationStatus = {}));
